import type { BanknoteCatalog, BanknoteDesign } from '../models/BanknoteTypes';
import type { IBanknoteCatalogRepository } from '../repository/IBanknoteCatalogRepository';

/**
 * Katalog erişim servisi — tasarım sorguları.
 */
export class BanknoteCatalogService {
  private catalog: BanknoteCatalog | null = null;

  constructor(private readonly repository: IBanknoteCatalogRepository) {}

  initialize(): void {
    this.catalog = this.repository.load();
  }

  getCatalog(): BanknoteCatalog {
    if (!this.catalog) {
      throw new Error('Banknote catalog is not initialized');
    }
    return this.catalog;
  }

  getAllDesigns(): readonly BanknoteDesign[] {
    return this.getCatalog().designs;
  }

  getDesignById(designId: string): BanknoteDesign {
    const design = this.getAllDesigns().find((item) => item.id === designId);
    if (!design) {
      throw new Error(`Banknote design not found: ${designId}`);
    }
    return design;
  }

  pickRandomDesign(): BanknoteDesign {
    const designs = this.getAllDesigns();
    const index = Math.floor(Math.random() * designs.length);
    const design = designs[index];
    if (!design) {
      throw new Error('Banknote catalog has no designs');
    }
    return design;
  }
}
